import { render, staticRenderFns } from "./footerBtm.vue?vue&type=template&id=053d865e&scoped=true"
import script from "./footerBtm.vue?vue&type=script&lang=js"
export * from "./footerBtm.vue?vue&type=script&lang=js"
import style0 from "./footerBtm.vue?vue&type=style&index=0&id=053d865e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d865e",
  null
  
)

export default component.exports